import PropTypes from 'prop-types';
import InteractionLabelField from 'apps/interactions/components/create/interaction-label-field';

const StatusField = ({ onChange, onBlur, name, value, values, required = false, field, meta, helpers }) => {
  return (
    <InteractionLabelField
      label="status"
      interaction={values}
      onChange={(label, val) => {
        const existing = { ...value };
        existing[label] = val;
        onChange({ target: { name, value: existing } });
      }}
      onClose={() => {
        onBlur({ target: { name } });
      }}
    />
  );
};

StatusField.propTypes = {
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  name: PropTypes.string,
  value: PropTypes.object,
  values: PropTypes.object,
  required: PropTypes.bool,
  field: PropTypes.shape({
    name: PropTypes.string,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    value: PropTypes.any,
    checked: PropTypes.bool,
    multiple: PropTypes.bool,
  }),
  meta: PropTypes.shape({
    error: PropTypes.string,
    initialError: PropTypes.string,
    initialTouched: PropTypes.bool,
    initialValue: PropTypes.any,
    touched: PropTypes.bool,
    value: PropTypes.any,
  }),
  helpers: PropTypes.shape({
    setValue: PropTypes.func,
    setTouched: PropTypes.func,
    setError: PropTypes.func,
  }),
};

export default StatusField;
